import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import UploadReportComp from "./Component/UploadReportComp"


const UploadReport =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <UploadReportComp />
        </div>
        <Footer />
        </>
    )
}

export default UploadReport